import {useEffect, useState} from 'react';
import { decodeStorage } from 'newFunctions/storageBase64';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { getMovements } from 'services/Movements'
import { useHistory } from 'react-router-dom'
import useTokenNew from './useTokenNew';

import { dateFormat } from 'newFunctions/dateFormat';

export default function useMovimientos() {

    const { access_token, isValid } = useTokenNew({name: 'useMovimientos'})
    const history = useHistory()
    const cardending = decodeStorage('cardending')
    const [ loading, setLoading ] = useState(true)

    const [ response, setResponse ] = useState()
    const [ respMovements, setRespMovements ] = useState()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Movements Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])
    

    let tiempo = new Date()
    let month
    if(tiempo?.getMonth() < 9){
        month = "0" + (tiempo?.getMonth() +1)
    }
    else{
        month = tiempo.getMonth() + 1
    }
    let periodoInicial =  String( tiempo?.getFullYear() ) + month

    const [period, setPeriod] = useState(periodoInicial)
    useEffect(()=>{
        if(isValid){
            if(access_token){
                if(cardending){
                    getMovements({cardending: cardending , period: period})
                    .then(setResponse)
                }else{
                    history.push(`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`)
                }
            }
        }
    },[access_token, period , isValid])

    const [errorCode, setErrorCode] = useState()
    const [cargos, setCargos] = useState(0.0)
    const [abonos, setAbonos] = useState(0.0)
    useEffect(()=>{
        if(response){
            if(response.statusCode === 200){
                setLoading(false)
                if(response.data){
                    if(response.data.segmentos){
                        setRespMovements(response?.data?.segmentos)
                    }
                    setCargos(response?.data?.sumcargo)
                    setAbonos(response?.data?.sumabono)
                }
            }
            else if(response?.statusCode >= 400 && response?.statusCode <= 499){
                let codeError = JSON.parse(response?.data)
                setErrorCode(codeError)
                setLoading(false)
            }
            else if(response.statusCode >= 500){
                setErrorCode(response?.statusCode)
                setLoading(false)
            }
        }
    },[response])

    return {
        loading,
        respMovements,
        cargos,
        abonos,
        setPeriod,
        errorCode
    }
}


export function useMovimientosModal(errorCode, respMovements, setPeriod) {
    // funciones para mostrar el modal
        const [showModal, SetShowModal] = useState(false);
        const showModalErrorCode = () => SetShowModal(true);
        const handleClose = () => SetShowModal(false);
        const lastConsultData =  decodeStorage('lastConsultData')
        useEffect(()=>{
            if(errorCode <= 499){
                showModalErrorCode()
            }
        },[errorCode])
    
        const [revolvente, setRevolvente] = useState()
        useEffect(()=>{
            if(respMovements){
                setRevolvente(respMovements)
            }
        },[respMovements])
    
        const [billDate, setBillDate] = useState("01-Ene-21")
        useEffect(()=>{
            if(lastConsultData[0]?.payday_limit !== 0){
                setBillDate( dateFormat(lastConsultData[0]?.payday_limit) )
            }
        },[])
    
    
        const [opcionSeleccionada, setOpcionSeleccionada] = useState(false);
        const [mostrarPeriodo, setMostrarPeriodo] = useState(false);
    
    
        let tiempo = new Date()
        let month
        let monthA
        let monthPA
        let year = tiempo.getFullYear()
        let yearA
        let yearPA
        if(tiempo.getMonth() === 0){
            month = "01"
            monthA = "12"
            monthPA = '11'
            yearA = year -1
            yearPA = year -1
        }
        else if(tiempo.getMonth() === 1){
            month = "02"
            monthA = "01"
            monthPA = "12"
            yearA = year
            yearPA = year -1
        }
        else if(tiempo.getMonth() >= 2 && tiempo.getMonth() <= 11){
            if((tiempo.getMonth() +1) >= 10  ){
                month = String(tiempo.getMonth() + 1)
            }else{
                month = "0" + (tiempo.getMonth() +1)
            }
            if((tiempo.getMonth()) >= 10  ){
                monthA = String(tiempo.getMonth())
            }else{
                monthA = "0" + tiempo.getMonth()
            }
            if((tiempo.getMonth() -1) >= 10  ){
                monthPA = String(tiempo.getMonth() -1)
            }else{
                monthPA = "0" + (tiempo.getMonth() -1)
            }
            yearA = year
            yearPA = year
        }
    
        let periodoInicial =  year +'-'+ month
        let periodoAnterior =  yearA +'-'+ monthA
        let periodoPrevioA =  yearPA +'-'+ monthPA
    
        let periodos = [
            { "id": 0, "periodo": `Actual (${periodoInicial})` },
            { "id": 1, "periodo": `Anterior (${periodoAnterior})` },
            { "id": 2, "periodo": `Previo al anterior (${periodoPrevioA})` }];
    
        // muestra modal periodos
        const handleMostrarPeriodos = () => {
            setMostrarPeriodo(!mostrarPeriodo);
        };
    
        // ocultar modal periodos
        const cerrar = () => {
            setMostrarPeriodo(false);
        };
    
        // actualizar opcion seleccionada en modal
        const aceptar = (opcion) => {
            let periodoSelected = opcion.replace('Anterior (','').replace('Previo al anterior (','').replace('Actual (','').replace(')','').replace('-','')
            setPeriod(periodoSelected)
            setOpcionSeleccionada(opcion);
        };

    return {
        billDate,
        opcionSeleccionada,
        periodos,
        revolvente,
        mostrarPeriodo,
        periodos,
        showModal,
        errorCode,
        aceptar,
        cerrar,
        handleClose,
        setMostrarPeriodo,
        setOpcionSeleccionada,
        handleMostrarPeriodos
    }
}